import { getContext } from "@icg360/pi-syntax-tools";
import { referenceTables } from "../reference-tables";
import { stringifyValue } from "../utils/stringify-value";
import { tryExecSyntaxForExpression } from "./execute-syntax";
import { handleCount } from "./iterable-count";
import { handleValidation } from "./term-validation";
export function executeExpression(state, exp, origin) {
    // This is the only expression on the actual iterable.
    if (exp.type === "count") {
        handleCount(state, exp);
        return;
    }
    // If these expresions didn't originate from an iterable index then we need
    // to run the expression on each index of the iterable.
    if (exp.iterableName && exp.iterableName !== (origin === null || origin === void 0 ? void 0 : origin.iterableName)) {
        for (let i = 0; i < state.iterables[exp.iterableName].count; i += 1) {
            executeExpression(state, exp, {
                iterableName: exp.iterableName,
                iterableIndex: i,
            });
        }
        return;
    }
    const iterableIndex = origin === null || origin === void 0 ? void 0 : origin.iterableIndex;
    if (exp.type === "validation") {
        handleValidation(state, exp, iterableIndex);
        return;
    }
    const { termName, iterableName } = exp;
    const term = getTerm(state, termName, iterableName, iterableIndex);
    if (exp.type === "basic" && exp.name === "required" && !term.isRelevant) {
        term.isRequired = false;
        return;
    }
    const context = getContext({
        env: state.env,
        meta: referenceTables[state.key].model.meta,
        terms: state.terms,
        iterables: state.iterables,
        this: iterableName && iterableIndex !== undefined
            ? {
                index: iterableIndex,
                position: iterableIndex + 1,
                term,
                iterable: state.iterables[iterableName],
                terms: state.iterables[iterableName].instances[iterableIndex].terms,
            }
            : {
                term,
            },
    });
    if (exp.type === "enums-relevant") {
        handleEnumsRelevant(state, exp, context, iterableIndex);
        return;
    }
    const output = tryExecSyntaxForExpression(exp.syntax, context, exp, iterableIndex);
    switch (exp.name) {
        case "calculate":
            term.value = stringifyValue(output, term);
            if (state.phase === "INITIAL") {
                term.ready = term.value;
            }
            break;
        case "label":
            term.label = String(output);
            break;
        case "relevant":
            term.isRelevant = Boolean(output);
            break;
        case "required":
            term.isRequired = Boolean(output);
            break;
        case "readonly":
            term.isReadonly = Boolean(output);
            break;
        default:
            throw new Error(`Unknown type: ${exp.name}`);
    }
}
export function executeExpressions(state, expressions, origin) {
    if (!expressions) {
        return;
    }
    for (const exp of expressions) {
        executeExpression(state, exp, origin);
    }
}
function getTerm(state, termName, iterableName, iterableIndex) {
    if (iterableName && iterableIndex !== undefined) {
        return state.iterables[iterableName].instances[iterableIndex].terms[termName];
    }
    return state.terms[termName];
}
function handleEnumsRelevant(state, exp, context, iterableIndex) {
    const { termName, iterableName } = exp;
    const term = getTerm(state, termName, iterableName, iterableIndex);
    for (const relExp of exp.items) {
        if (!term.enums || relExp.enumIndex >= term.enums.length) {
            throw new Error(`Enum index ${relExp.enumIndex} does not exist on term ${termName}`);
        }
        const output = tryExecSyntaxForExpression(relExp.syntax, context, exp, iterableIndex);
        term.enums[relExp.enumIndex].isRelevant = Boolean(output);
    }
}
//# sourceMappingURL=execute-expressions.js.map